import { API_BASE_URL } from '../config/apiEndpoints';

/** Prefer structured first/last name over stale display_name (e.g. after venue settings overwrite). */
export function resolveUserDisplayName(userProfile, currentUser) {
  const fromParts = [
    userProfile?.first_name || userProfile?.firstName,
    userProfile?.last_name || userProfile?.lastName,
  ]
    .filter(Boolean)
    .join(' ')
    .trim();
  if (fromParts) return fromParts;

  return (
    userProfile?.display_name ||
    userProfile?.displayName ||
    currentUser?.displayName ||
    ''
  ).trim();
}

export async function fetchBackendUserProfile(accessToken) {
  if (!accessToken) return { ok: false, status: 0, profile: null };

  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    return { ok: false, status: response.status, profile: null };
  }

  const profile = await response.json();
  return { ok: true, status: response.status, profile };
}

export function mergeStoredUserWithBackendProfile(storedUser, backendUser) {
  if (!storedUser || !backendUser) return storedUser;

  const firstName = backendUser.first_name ?? storedUser.first_name ?? '';
  const lastName = backendUser.last_name ?? storedUser.last_name ?? '';
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim();

  return {
    ...storedUser,
    first_name: firstName,
    last_name: lastName,
    phone: backendUser.phone ?? storedUser.phone ?? '',
    profile_image_url: backendUser.profile_image_url ?? storedUser.profile_image_url ?? '',
    display_name: displayName || storedUser.display_name || '',
  };
}
